import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { fetchWarehouseItems } from "../../../../../../enums/queryFunction/Fetch";
import { WAREHOUSE_ITEMS } from "../../../../../../enums/QueryKeys";

export function useGetClinicWarehouseItems(clinicId, { categoryId, supplierId, search, sort, page, size } = {}) {
  const { data, isLoading, isFetching, error } = useQuery({
    queryKey: [WAREHOUSE_ITEMS, clinicId, categoryId, supplierId, search, sort, page, size],
    queryFn: () => fetchWarehouseItems(clinicId, { categoryId, supplierId, search, sort, page, size }),
    enabled: Boolean(clinicId),
    placeholderData: keepPreviousData,
    staleTime: 5000,
  });

  return { data, isLoading, isFetching, error };
}
